import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export default class ProductsRepository extends Repository {
  getVisibilityProducts() {
    throw new Error('[ProductsRepository#getVisibilityProducts] must be implemented')
  }

  getPaymemntAdProduct() {
    throw new Error('[ProductsRepository#getPaymemntAdProduct] must be implemented')
  }
}
